import { render } from "./UroplastPremiumPage.vue?vue&type=template&id=fe726552"
import script from "./UroplastPremiumPage.vue?vue&type=script&lang=js"
export * from "./UroplastPremiumPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__